export const CATEGORIES = [
  "All",
  "Tourism",
  "Business",
  "Crime & Safety",
  "Politics",
  "Community",
  "Sports",
];

// Strict 2-color palette: teal default, red for high-alert
export const TEAL = "#0AADA0";
export const RED = "#E63946";

// All categories use teal except Crime & Safety which is red (semantic)
export const CATEGORY_COLORS = {
  Tourism: TEAL,
  Business: TEAL,
  "Crime & Safety": RED,
  Politics: TEAL,
  Community: TEAL,
  Weather: TEAL,
  Sports: TEAL,
  Entertainment: TEAL,
};

export const ISLANDS = [
  { slug: "all", name: "All Islands", flag: "🌍", color: "#0AADA0" },
  { slug: "aruba", name: "Aruba", flag: "🇦🇼", color: "#0AADA0" },
  { slug: "curacao", name: "Curaçao", flag: "🇨🇼", color: "#7F77DD" },
  { slug: "bonaire", name: "Bonaire", flag: "🇧🇶", color: "#3BB273" },
  { slug: "stmaarten", name: "St. Maarten", flag: "🇸🇽", color: "#E63946" },
];

export const ISLAND_BY_SLUG = ISLANDS.reduce((acc, i) => {
  acc[i.slug] = i;
  return acc;
}, {});

export const ISLAND_META_DESC = {
  all: "Dutch Caribbean news in English — aggregated daily from leading local sources",
  aruba: "All of Aruba's news in English — aggregated daily from leading local sources",
  curacao: "All of Curaçao's news in English — aggregated daily from leading local sources",
  bonaire: "All of Bonaire's news in English — aggregated daily from leading local sources",
  stmaarten: "All of St. Maarten's news in English — aggregated daily from leading local sources",
};

export const SOURCES_BY_ISLAND = {
  aruba: [
    { name: "24ora", url: "https://www.24ora.com" },
    { name: "Noticia Cla", url: "https://noticiacla.com" },
    { name: "AWE24", url: "https://awe24.com" },
    { name: "Mas Noticia", url: "https://masnoticia.com" },
  ],
  curacao: [
    { name: "Nu.cw", url: "https://nu.cw" },
    { name: "Knipselkrant Curaçao", url: "https://knipselkrant-curacao.com" },
    { name: "Curaçao Chronicle", url: "https://www.curacaochronicle.com" },
  ],
  bonaire: [
    { name: "InfoBonaire", url: "https://infobonaire.com" },
    { name: "Bonaire Island", url: "https://bonaireisland.com" },
    { name: "Bonaire Reporter", url: "https://bonairereporter.com" },
  ],
  stmaarten: [
    { name: "The Daily Herald", url: "https://www.thedailyherald.sx" },
    { name: "SXM Island Time", url: "https://sxmislandtime.com" },
    { name: "721 News", url: "https://721news.com" },
  ],
};

export const ALL_SOURCES = Object.values(SOURCES_BY_ISLAND).flat();

export const timeAgo = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)} minute${Math.floor(diff / 60) === 1 ? "" : "s"} ago`;
  if (diff < 86400) {
    const h = Math.floor(diff / 3600);
    return `${h} hour${h === 1 ? "" : "s"} ago`;
  }
  if (diff < 86400 * 7) {
    const d2 = Math.floor(diff / 86400);
    return `${d2} day${d2 === 1 ? "" : "s"} ago`;
  }
  return d.toLocaleDateString();
};
